import { render, staticRenderFns } from "./SaiDateDetail.vue?vue&type=template&id=54d8f3cc&scoped=true&"
import script from "./SaiDateDetail.vue?vue&type=script&lang=js&"
export * from "./SaiDateDetail.vue?vue&type=script&lang=js&"
import style0 from "./SaiDateDetail.vue?vue&type=style&index=0&id=54d8f3cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d8f3cc",
  null
  
)

export default component.exports